import type { Step } from "react-joyride";

export const promotionRecordsTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ສະແດງລາຍການບັນທຶກການເລື່ອນຕຳແໜ່ງ. ທ່ານສາມາດກັ່ນຕອງຕາມພະນັກງານ, ເດືອນ/ປີ, ຕຳແໜ່ງ ແລະ ເບິ່ງລາຍລະອຽດ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="promotion-records-toolbar"]',
    content:
      "ກົດ 'ສ້າງບັນທຶກການເລື່ອນຕຳແໜ່ງ' ເພື່ອບັນທຶກການເລື່ອນຕຳແໜ່ງໃໝ່. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="promotion-records-filter"]',
    content:
      "ເລືອກພະນັກງານ, ປີ/ເດືອນ, ຕຳແໜ່ງ ແລະ ຄົ້ນຫາເພື່ອກັ່ນຕອງລາຍການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="promotion-records-table"]',
    content:
      "ຕາຕະລາງລາຍການບັນທຶກການເລື່ອນຕຳແໜ່ງ. ກົດ 'ລາຍລະອຽດ' ເພື່ອເບິ່ງຂໍ້ມູນເຕັມ.",
    placement: "top",
  },
];
